"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _iconsReact = require("@carbon/icons-react");

var _useId = require("../../internal/useId");

var _usePrefix = require("../../internal/usePrefix");

/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
function ProgressBar(_ref) {
  var _classNames;

  var className = _ref.className,
      helperText = _ref.helperText,
      hideLabel = _ref.hideLabel,
      label = _ref.label,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'big' : _ref$size,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? 'active' : _ref$status,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      value = _ref.value;
  var labelId = (0, _useId.useId)('progress-bar');
  var helperId = (0, _useId.useId)('progress-bar-helper');
  var prefix = (0, _usePrefix.usePrefix)();
  var isFinished = status === 'finished';
  var isError = status === 'error';
  var indeterminate = !isFinished && !isError && (value === null || value === undefined);
  var cappedValue = value;

  if (cappedValue > max) {
    cappedValue = max;
  }

  if (cappedValue < 0) {
    cappedValue = 0;
  }

  if (isError) {
    cappedValue = 0;
  } else if (isFinished) {
    cappedValue = max;
  }

  var percentage = cappedValue / max;
  var wrapperClasses = (0, _classnames.default)("".concat(prefix, "--progress-bar"), "".concat(prefix, "--progress-bar--").concat(size), "".concat(prefix, "--progress-bar--").concat(type), (_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(prefix, "--progress-bar--indeterminate"), indeterminate), (0, _defineProperty2.default)(_classNames, "".concat(prefix, "--progress-bar--finished"), isFinished), (0, _defineProperty2.default)(_classNames, "".concat(prefix, "--progress-bar--error"), isError), _classNames), className);
  var labelClasses = (0, _classnames.default)("".concat(prefix, "--progress-bar__label"), (0, _defineProperty2.default)({}, "".concat(prefix, "--visually-hidden"), hideLabel));
  var StatusIcon = null;

  if (isError) {
    StatusIcon = _iconsReact.ErrorFilled16;
  } else if (isFinished) {
    StatusIcon = _iconsReact.CheckmarkFilled16;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: labelClasses,
    id: labelId
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefix, "--progress-bar__label-text")
  }, label), StatusIcon && /*#__PURE__*/_react.default.createElement(StatusIcon, {
    className: "".concat(prefix, "--progress-bar__status-icon")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefix, "--progress-bar__track"),
    role: "progressbar",
    "aria-invalid": isError,
    "aria-labelledby": labelId,
    "aria-describedby": helperText ? helperId : null,
    "aria-valuemin": !indeterminate ? 0 : null,
    "aria-valuemax": !indeterminate ? max : null,
    "aria-valuenow": !indeterminate ? cappedValue : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefix, "--progress-bar__bar"),
    style: !isFinished && !isError ? {
      transform: "scaleX(".concat(percentage, ")")
    } : null
  })), helperText && /*#__PURE__*/_react.default.createElement("div", {
    id: helperId,
    className: "".concat(prefix, "--progress-bar__helper-text")
  }, helperText));
}

ProgressBar.propTypes = {
  /**
   * Additional CSS class names.
   */
  className: _propTypes.default.string,

  /**
   * The current progress as a textual representation.
   */
  helperText: _propTypes.default.string,

  /**
   * Whether the label should be visually hidden.
   */
  hideLabel: _propTypes.default.bool,

  /**
   * A label describing the progress bar.
   */
  label: _propTypes.default.string.isRequired,

  /**
   * The maximum value.
   */
  max: _propTypes.default.number,

  /**
   * Specify the size of the ProgressBar.
   */
  size: _propTypes.default.oneOf(['small', 'big']),

  /**
   * Specify the status.
   */
  status: _propTypes.default.oneOf(['active', 'finished', 'error']),

  /**
   * Defines the alignment variant of the progress bar.
   */
  type: _propTypes.default.oneOf(['default', 'inline', 'indented']),

  /**
   * The current value.
   */
  value: _propTypes.default.number
};
var _default = ProgressBar;
exports.default = _default;